<div id="main" class="internal">
  <div id="complete-reservation" class="section complete-reservation">
    <div class="content-body">
      <div class="header-cp">
        <div class="icon">
          <img src="../../../assets/images/check.svg" alt="Image check" />
        </div>
        <div class="title">
          <h1>
            {{ "booking_confirmation.booking_confirmed_text" | translate }}
          </h1>
        </div>
      </div>
      <div class="content">
        <div class="card complete-res">
          <div class="img-restaurant">
            <img
              [src]="datasource!.img_url"
              alt="Image restaurant"
              onerror="this.onerror=null; this.src='../../../assets/images/alt_ristoranti.png'"
            />
            <!-- <img src="../../../assets/images/alt_ristoranti.png" alt="Image restaurant"> -->
          </div>
          <div class="title">
            <h2>{{ datasource!.restaurant_name }}</h2>
          </div>
        </div>

        <div class="card complete-res">
          <div class="summary-box">
            <div class="list">
              <div class="item">
                <div class="icon">
                  <img
                    src="../../../assets/images/calendar-slot.svg"
                    alt="Calendar slot"
                  />
                </div>
                <div class="text">
                  <div class="title">
                    {{ dateService.dateToSummaryString(datasource!.date!) }}.
                    {{ datasource!.date | date : "dd/MM/yyyy" }}
                    {{ "at" | translate }}
                    {{ datasource!.date_time }}
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img
                    src="../../../assets/images/ticket-slot.svg"
                    alt="Calendar"
                  />
                </div>
                <div class="text">
                  <div class="title">
                    {{ "booking_confirmation.booked_by" | translate }}
                    {{ datasource!.booked_by }}
                  </div>
                </div>
              </div>
              <div class="item user-group">
                <div class="icon">
                  <img
                    src="../../../assets/images/users-group.svg"
                    alt="Ticket"
                  />
                </div>
                <div class="text">
                  <div class="title no-margin">
                    {{ "booking_confirmation.booking_for" | translate }}
                    {{ datasource!.companion!.length }}
                    {{ "booking_confirmation.guests" | translate }}
                  </div>
                  <div class="groups">
                    <ul>
                      @for(el of datasource!.companion!; track el) {
                      <li>{{ el }}</li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="message">
          <div class="icon">
            <img src="../../../assets/images/Info.svg" alt="Info icon" />
          </div>
          <div
            class="text"
            [innerHTML]="
              'booking_confirmation.message'
                | translate
                  : {
                      phone_number: phone_number
                    }
            "
          ></div>
        </div>
      </div>
      <div class="buttons">
        <button class="costa-button" type="button" (click)="Close()">
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
